import script from "./alert.vue?vue&type=script&setup=true&lang=js"
export * from "./alert.vue?vue&type=script&setup=true&lang=js"

import "./alert.vue?vue&type=style&index=0&id=03be5449&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03be5449"]])

export default __exports__